import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  bigList: {
    height: 300,
  },
  card: {
    maxHeight: 300,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  label: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  boxMarginLeft: {
    marginLeft: ({ index, level }: { index?: number; level?: number }) =>
      !index ? -5 : level ? (level - 2) * 7 : 0,
    '& svg': {
      fontSize: 15,
    },
  },
  labelWeight: {
    fontWeight: '500',
  },
  listHeader: {
    borderBottom: `solid 1px ${theme.palette.grey[100]}`,
    height: 50,
    marginLeft: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: theme.spacing(2),
  },
  listItem: {
    gap: theme.spacing(2),
    paddingLeft: ({ level }: { level?: number }) => 16 + (level || 0) * 10,
  },
  listItemDisabled: {
    filter: 'grayscale(1)',
    pointerEvents: 'none !important' as any,
  },
  listItemIcon: {
    minWidth: 20,
    position: 'relative',
    right: theme.spacing(-0.2),
  },
  listItemSecondaryLabel: {
    display: 'flex',
  },
  listItemSelected: {
    backgroundColor: 'white !important',
  },
  listMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    margin: theme.spacing(2),
  },
  popper: {
    zIndex: theme.zIndex.tooltip,
  },
  secondaryLabel: {
    marginLeft: theme.spacing(1),
  },
  wrapperListItemRight: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'flex-end',
  },
}));
